var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPolicyOn = function SvgPolicyOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 26 26"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#4A4D55",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    clipPath: "url(#policy_on_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4A4D55",
    d: "M19 4H7a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8 8.056s2.757-.477 5 1.355V18c-2.243-1.84-5-1.355-5-1.355zM18 8.056s-2.757-.477-5 1.355V18c2.243-1.84 5-1.355 5-1.355z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "policy_on_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h26v26H0z"
  })))));
};
export default SvgPolicyOn;